<template>
  <div
    v-if="$store.getters.isRtbFlowPossible && paymentDetails"
    class="my-6"
  >
    <PriceBreakdown :list="paymentDetails.priceBreakdown" />

    <div class="border-0 border-t border-solid border-grey-300 pt-4 mt-4 font-semibold text-base flex justify-between">
      <div>Total</div>
      <div class="text-right">
        {{ paymentDetails.grossPrice.formatted }}
        <div class="text-grey-600 text-xs font-normal mt-1">
          ({{ $store.state.l10n.valueAddedTaxName }} included)
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PriceBreakdown from '@/components/cabinet/Payment/PriceBreakdown.vue';

export default {
  name: 'EnquiryPricingTable',
  components: { PriceBreakdown },
  computed: {
    paymentDetails() {
      return this.$store.state.pricing.paymentDetails;
    },
  },
};
</script>
